import React from 'react'

import SessionEndHeadingIcon from '../../assets/icons/session-end-heading-icon.svg'
import ButtonBackToPartner from 'components/Buttons/ButtonBackToPartner/ButtonBackToPartner'
import useTextContents from 'common/hooks/useTextContents'
import { BACK_TO_PARTNER_LINK_TYPES } from 'components/Buttons/ButtonBackToPartner/BackToPartnerButtonProps'

import './SessionEndPageStyles.scss'


/**
 * Komponent obsługujący stronę "Sesja wygasła" 
*/
const SessionEndPage = (): JSX.Element => {

   const sessionEndPageTextContents = useTextContents()

   return (
      <div className='session-end-page-outer-wrapper'>
         <img className='session-end-page-heading-icon' src={SessionEndHeadingIcon} alt='sesja wygasła'/>
         <h1 className='session-end-page-heading-text'>{sessionEndPageTextContents('sessionEndPage.header')}</h1>
         <div className='session-end-page-description-text-wrapper'>
            <p>{sessionEndPageTextContents('sessionEndPage.mainContent.part1')}</p>
            <p>{sessionEndPageTextContents('sessionEndPage.mainContent.part2')}</p>
         </div>
         <ButtonBackToPartner linkType={BACK_TO_PARTNER_LINK_TYPES.FAILURE} />
      </div>
   )
}

export default SessionEndPage